<template>
  <message-form>
    <ButtonCreate class="mt_m"/>
  </message-form>
</template>

<script>
import MessageForm from '@/components/Message/Form'
import ButtonCreate from '@/components/Message/ButtonCreate'

export default {
  components: {
    MessageForm,
    ButtonCreate
  },
  created: async function () {
    this.$store.dispatch(
      'message/resetForm',
      this.$route.params.id
    )
  }
}
</script>
